import { Sys } from 'contentful';

export abstract class Model {

    public get id () {
        return this.__sys.id;
    }

    public abstract readonly contextLabel: string;
    public abstract readonly contextValue: string;
    protected readonly extraContext: { [key: string]: string | number };

    protected __parent: Model;
    protected __context: any;
    private readonly __children: Model[] = [];

    public get parent () {
        return this.__parent;
    }

    public get context () {
        return this.__context;
    }

    constructor (
        fields,
        private readonly __sys: Sys,
    ) {
        Object.assign(this, fields);
        this.assignParents(fields);
    }

    private assignParents (fields: any) {
        if (Array.isArray(fields)) {
            return fields.forEach(field => this.assignParents(field));
        }

        if (fields instanceof Model) {
            fields.__parent = this;
            this.__children.push(fields);

            return;
        }

        if (typeof fields === 'object') {
            Object.keys(fields).forEach(key => {
                const child = fields[key];
                this.assignParents(child);
            });
        }
    }

    public generateContexts () {
        this.__children.forEach(child => child.generateContexts());

        let section: string;
        let subsection: string;
        if (this.parent) {
            section    = this.parent.parent ? this.parent.parent.contextValue : this.parent.contextValue;
            subsection = this.parent.contextValue;
        } else {
            section    = this.contextValue;
            subsection = null;
        }

        this.__context = {
            section,
            subsection,
            label: this.contextLabel,
            value: this.contextValue,
            ...(this.extraContext || {}),
        };
    }
}
